const filteredObj = (obj) =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value) {
      acc[key] = value;
    }
    return acc;
  }, {});

export default filteredObj;
